export const stepTwoData = [
  {
    heading: "What to Consider Before Using MinEMI’s Balance Transfer Tool",
    subheading:
      "While MinEMI’s platform makes balance transfers seamless, there are critical factors you should evaluate:",
    infoList: [
      {
        info: "Processing Fees: ",
        description:
          " Transferring loans often involves a processing fee (1-3% of the outstanding amount). MinEMI highlights this cost upfront to help you decide.",
      },
      {
        info: "Prepayment Penalties:",
        description:
          " Some lenders charge penalties for closing loans early. MinEMI checks for these charges and calculates your net savings for you.",
      },
      {
        info: "Loan Tenure and Terms:",
        description:
          " Transferring early in the loan tenure provides maximum savings. MinEMI’s algorithms evaluate your current position and recommend the best time for a transfer.",
      },
      {
        info: "New Lender Benefits:",
        description:
          "Compare repayment flexibility, tenure options, and hidden costs. MinEMI simplifies this comparison to ensure you choose the most beneficial lender.",
      },
      {
        info: " Credit Score Compatibility:",
        description:
          " Your credit score directly impacts eligibility and loan terms. MinEMI provides detailed credit analysis and matches you with lenders suited to your profile.",
      },
    ],
    // second list data

    secondHeading: "Steps to Transfer Your Personal Loan with MinEMI",

    secondInfoList: [
      {
        info: " Analyze Your Loan Details: ",
        description:
          "Use MinEMI’s Balance Transfer Calculator to review your outstanding amount, tenure, and current interest rate.",
      },
      {
        info: "Explore Lenders with MinEMI:",
        description:
          "MinEMI provides a curated list of lenders offering competitive rates and flexible terms.",
      },
      {
        info: "Submit Documents via MinEMI:",
        description:
          " Submit your loan statements, ID proof, and income details securely through the MinEMI platform.",
      },
      {
        info: " NOC and Foreclosure Statement:",
        description:
          "MinEMI assists in obtaining the No Objection Certificate (NOC) and foreclosure statement from your existing lender.",
      },
      {
        info: " Finalize the Transfer:",
        description:
          "Once approved, the new lender pays off your old loan, and your balance transfer is complete. MinEMI ensures you receive a closure confirmation for your old loan.",
      },
    ],
  },
];

export const waysToPayOff = [
  {
    tableinfo:
      "Understanding the impact of your debt repayment strategy without utilizing a balance transfer can help you make informed financial decisions. Below is a table illustrating different scenarios with varying monthly payments and interest rates.",

    infoheading: "Key Insights:",

    infoList: [
      {
        info: "Higher Monthly Payments: ",
        description:
          " Opting for higher monthly payments can significantly reduce the total interest paid and shorten the repayment period.",
      },
      {
        info: "Extended Repayment Periods: ",
        description:
          " Lower monthly payments might seem manageable, but they result in a much higher total cost due to increased interest.",
      },
      {
        info: "High-Interest Rates:",
        description:
          " Managing debts with high APRs without a balance transfer can lead to substantial financial strain over time. Consider exploring balance transfer options to alleviate the interest burden.",
      },
    ],
    ways: "Ways to Pay Off Debt Faster",
    waysInfolist: [
      {
        info: "Increase Monthly Payments:",
        description:
          " Allocate more towards repayment to reduce interest and shorten the tenure.",
      },
      {
        info: "Consolidate Debt:",
        description:
          "  Use Minemi’s balance transfer options to combine loans at a lower interest rate.",
      },
      {
        info: "Prioritize High-Interest Debts:",
        description: " Pay off the costliest debts first for better savings.",
      },
      {
        info: "Stick to a Budget:",
        description: "Allocate fixed amounts to repay debt consistently.",
      },
    ],
  },
];

export const stepThreeData = [
  {
    heading: "How MinEMI’s Balance Transfer Benefits You",

    infoList: [
      {
        info: "Lower Your Monthly EMIs: ",
        description:
          "MinEMI helps you find the best interest rates, resulting in reduced EMIs.",
      },
      {
        info: "Save on Interest Costs:",
        description:
          " Transferring to a lower rate minimizes the total interest paid over the loan tenure.",
      },
      {
        info: "Flexible Repayment Options:",
        description:
          "Enjoy extended tenures and better repayment flexibility tailored to your needs.",
      },
      {
        info: "Easy Loan Consolidation:",
        description:
          "Consolidate multiple personal loans into one manageable repayment through MinEMI.",
      },
    ],
    // minemi tip list
    minemiTip: "Tips for Using MinEMI’s Balance Transfer Calculator",
    tipSubhead:
      "Make the most of MinEMI’s Balance Transfer Calculator with these tips:",
    tipInfoList: [
      {
        info: "Gather All Loan Details:",
        description:
          "Keep your outstanding principal amount, remaining tenure, and current interest rate handy for accurate results.",
      },
      {
        info: "Experiment with Different Scenarios:",
        description:
          "Adjust the new interest rate and tenure in the calculator to visualize potential savings.",
      },
      {
        info: "Consider Total Savings:",
        description:
          "MinEMI shows how much you save on EMIs and total interest, empowering you to make informed decisions.",
      },
      {
        info: "Compare Multiple Offers:",
        description:
          "MinEMI’s calculator helps you explore various lenders, ensuring you pick the best deal.",
      },
    ],
  },
  {
    transferlone: "When Not to Transfer Your Loan",
    subhead:
      "While balance transfers offer many benefits, there are times when it might not be the best option:",
    infoList: [
      {
        info: "When You’re Nearing Loan Completion:",
        description:
          "If most of the loan tenure is over, the savings from a transfer may be minimal.",
      },
      {
        info: "When Processing Fees Outweigh Savings:",
        description:
          "Use MinEMI’s tools to calculate if the savings justify the costs involved in transferring.",
      },
      {
        info: "If Your Credit Score Has Dropped:",
        description:
          "A lower credit score might lead to higher interest rates, making the transfer less attractive.",
      },
    ],
    paraOne: "How MinEMI Simplifies the Balance Transfer Journey",
    paraTwo:
      "MinEMI offers a one-stop solution for personal loan balance transfers. From analyzing your loan to connecting you with the best lenders, MinEMI ensures a seamless and secure experience. Plus, with features like real-time savings calculation and personalized loan recommendations, you can trust MinEMI to make every step easy.",
    paraThree: "Start Your Balance Transfer Now!",
  },
];

// stepThree Calculator

export const monthlyPayment = [
  {
    id: 1,
    title: "Monthly payment calculator",
    description:
      "This calculator shows you exactly how much you would have to pay each month to eliminate credit card debt within a specific time frame.",
  },
];

export const stepFourData = [
  {
    heading: "How Credit Card Balance Transfers Work in India",
    headDescription:
      "Managing high-interest credit card debt can be challenging. In India, several financial institutions offer solutions to help you manage and reduce this burden:",

    subheadOne: "Personal Loan on Credit Card (PLCC):",
    subheadOneList: [
      {
        heading: "Overview:",
        description:
          "Some banks provide pre-approved personal loans to their credit cardholders, allowing them to access funds at interest rates lower than standard credit card rates.",
      },
      {
        heading: "Benefits:",
        description:
          " These loans often come with flexible repayment tenures and fixed EMIs, making debt management more predictable.",
      },
      {
        heading: "Example: ",
        description:
          "HDFC Bank offers a ‘Loan on Credit Card’ facility, providing instant loans to cardholders with minimal documentation.",
      },
    ],
    subheadTwo: "Balance Transfer Products:",
    subheadTwoList: [
      {
        heading: "Overview:",
        description:
          "This facility enables you to transfer outstanding balances from one or multiple credit cards to another card with a lower interest rate.",
      },
      {
        heading: "Benefits:",
        description:
          " By consolidating debt under a single card with a lower rate, you can reduce overall interest expenses.",
      },
      {
        heading: "Example: ",
        description:
          "SBI Card offers a balance transfer option where you can transfer dues from other bank credit cards to an SBI Card at lower interest rates.",
      },
    ],
    subheadThree: "EMI Conversion Options:",
    subheadThreeList: [
      {
        heading: "Overview:",
        description:
          "Many banks allow you to convert your existing credit card dues into Equated Monthly Installments (EMIs).",
      },
      {
        heading: "Benefits:",
        description:
          " This approach breaks down your debt into manageable monthly payments, often at a lower interest rate than the standard credit card rate.",
      },
      {
        heading: "Example: ",
        description:
          " ICICI Bank provides an option to convert credit card transactions into EMIs, helping customers manage their finances better.",
      },
    ],

    headingTwo: "Key Considerations:",
    infoList: [
      {
        heading: "Interest Rates: ",
        description:
          "While these facilities offer lower rates than standard credit card charges, it’s essential to compare rates across different banks to ensure maximum savings.",
      },
      {
        heading: "Processing Fees:",
        description:
          " Be aware of any processing or transfer fees associated with these services, as they can impact overall savings.",
      },
      {
        heading: "Eligibility:",
        description:
          "  Banks may have specific eligibility criteria, such as a good credit score or a history of timely payments, to avail of these facilities.",
      },
    ],

    paraOne:
      "By exploring these options, you can choose a strategy that aligns with your financial goals and helps you manage credit card debt more effectively.",
  },
];

export const stepFiveContent = [
  {
    heading: "Choosing the Right Balance Transfer Option",
    headDescription:
      "Selecting an appropriate balance transfer option is crucial for effective debt management. Consider the following factors to make an informed decision:",

    subheadOne: "Balance Transfer Fees:",
    subheadOneList: [
      {
        heading: "Overview:",
        description:
          "Banks typically charge a fee for processing balance transfers, usually ranging between 1% to 3% of the transferred amount.",
      },
      {
        heading: "Consideration: ",
        description:
          "  Ensure that the interest savings from the lower rate outweigh the transfer fee. For instance, if you’re transferring ₹1,00,000 and the fee is 2%, you’ll incur a ₹2,000 charge.",
      },
    ],
    subheadTwo: "Interest Rate Differential:",
    subheadTwoList: [
      {
        heading: "Overview:",
        description:
          "The difference between your current interest rate and the new rate offered by the balance transfer option.",
      },
      {
        heading: "Consideration: ",
        description:
          " A significant reduction in the interest rate can lead to substantial savings. For example, moving from a 24% APR to a 12% APR can halve your interest expenses.",
      },
    ],
    subheadThree: "Lender’s Reputation and Practices:",
    subheadThreeList: [
      {
        heading: "Overview:",
        description:
          "The credibility and customer service quality of the new bank or financial institution.",
      },
      {
        heading: "Consideration: ",
        description:
          "  Opt for lenders known for transparent practices and efficient customer support. Research their debt collection methods to avoid potential issues.",
      },
    ],
    subheadFour: "Rewards and Benefits:",
    subheadFourList: [
      {
        heading: "Overview:",
        description:
          " Some credit cards offer rewards like cashback, travel points, or discounts.",
      },
      {
        heading: "Consideration: ",
        description:
          " While rewards are beneficial, prioritize lower interest rates and favorable terms over perks. However, if two options are similar in rates and fees, choose the one with better rewards.",
      },
    ],
    subheadFive: "Repayment Terms and Conditions:",
    subheadFiveList: [
      {
        heading: "Overview:",
        description: "The duration and flexibility of the repayment period.",
      },
      {
        heading: "Consideration: ",
        description:
          "  Ensure the repayment tenure aligns with your financial capacity. Longer tenures may reduce monthly payments but could increase total interest paid.",
      },
    ],
    tipTwo:
      "Before finalizing a balance transfer, calculate the total cost, including transfer fees and interest over the repayment period, to ensure genuine savings.",

    // text after second tip
  },
];
